//import css
import "./scss/main.scss";

//import components js
import "./components/carousel/carousel.js";
import "./components/loader/loader.js";
import "./components/rotate/rotate.js";
import "./components/skiplinks/skiplinks.js";

import "./js/browser-detect";
import "./js/lazyload";
//import "./js/check-visible";
